import { useContext, useState } from 'react'
import { AppState } from 'App';
import ModalPhoto from 'components/modals/ModalPhoto'

const PhotoGrid2 = ({photos, order}) => {

    const [appState, setAppState] = useContext(AppState)

    const numberPhotos = photos.length;
    const [modalPhotoOpen, setModalPhotoOpen] = useState(false)
    const [displayedPhoto, setDisplayedPhoto] = useState()

    return (
        <>
            {numberPhotos===1 &&
                <img
                    src={photos[0]}
                    onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                    onClick={() => setDisplayedPhoto(photos[0]) | setModalPhotoOpen(true)}
                    className="object-cover max-h-full rounded-lg cursor-pointer 2xl:w-190 w-160"
                    alt="alt text"
                />
            }
            {numberPhotos===2 &&
                <div className="flex flex-row space-x-4 2xl:space-x-8 h-96">
                    {photos.map(photo => (
                        <div key={photo} className="w-1/2 h-96">
                            <img
                                src={photo}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photo) | setModalPhotoOpen(true)}
                                className="object-cover w-full rounded-lg cursor-pointer h-96"
                                alt="alt text"
                            />
                        </div>
                    ))}
                </div>
            }
            {numberPhotos===3 &&
                <div className="flex flex-row space-x-8 h-104">
                    <div className="w-1/2 h-96">
                        <img
                            src={photos[0]}
                            onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                            onClick={() => setDisplayedPhoto(photos[0]) | setModalPhotoOpen(true)}
                            className="object-cover w-full rounded-lg cursor-pointer h-104"
                            alt="alt text"
                        />
                    </div>
                    <div className="flex flex-col w-1/2 space-y-8 h-96">
                        <div>
                            <img
                                src={photos[1]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[1]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                                id={`photo${order}`}
                            />
                        </div>
                        <div>
                            <img
                                src={photos[2]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[2]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                            />
                        </div>
                    </div>
                </div>
            }
            {numberPhotos===4 &&
                <div className="flex flex-row space-x-8 h-108">
                    <div className="flex flex-col w-1/2 space-y-8 h-108">
                        <div>
                            <img
                                src={photos[0]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[0]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                            />
                        </div>
                        <div>
                            <img
                                src={photos[1]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[1]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2 space-y-8 h-96">
                        <div>
                            <img
                                src={photos[2]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[2]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                            />
                        </div>
                        <div>
                            <img
                                src={photos[3]}
                                onLoad={() => setAppState(prevState => ({...prevState,loadingContext:null}))}
                                onClick={() => setDisplayedPhoto(photos[3]) | setModalPhotoOpen(true)}
                                className="object-cover w-full h-48 rounded-lg cursor-pointer"
                                alt="alt text"
                            />
                        </div>
                    </div>
                </div>
            }
            <ModalPhoto open={modalPhotoOpen} onClose={() => setModalPhotoOpen(false)} image={displayedPhoto}/>
        </>
    )
}

export default PhotoGrid2
